import {
  BULK_ACTIONS_LOADING,
  BULK_ACTIONS_SUCCESS,
  BULK_ACTIONS_FAILED,
} from "../types";

interface BulkActionsState {
  loading: boolean;
  data: any;
  error: string | null;
}

const initialState: BulkActionsState = {
  loading: false,
  data: null,
  error: null,
};

const recurringPaymentBulkActionsReducer = (
  state = initialState,
  action: any
): BulkActionsState => {
  switch (action.type) {
    case BULK_ACTIONS_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case BULK_ACTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case BULK_ACTIONS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default recurringPaymentBulkActionsReducer;
